// Callback jQuery
// evt = jQuery event
// 'this' = clicked letter
export function scrollToLetter() {
  // Get letter value & its related h3.storelist-body__letter
  const letter = this.innerText;
  const titleLetter = $(
    `#country-list-wrapper h3.storelist-body__letter:contains("${letter}")`
  );

  // If header is non-existent : exit
  if (titleLetter.length === 0) return;

  // Compute distance to scroll
  const headerHeight = $('#header').height();
  const $listBloc = $('.storelist-bloc-letters');
  const listBlocHeight = $listBloc.outerHeight(true);
  let distanceToScroll =
    titleLetter.offset().top - headerHeight - listBlocHeight;

  // If $listBloc is 'in-page' == not fixed to top == has class 'affix-top'
  // substract again the height of the bloc to distance to scroll
  // (the letter-list will disapear during scroll)
  if ($listBloc.hasClass('affix-top')) {
    distanceToScroll -= listBlocHeight;
  }

  // Scroll
  cube.ui.smoothScroll(distanceToScroll);
};

// Executed on init,
// For each letters, search related h3.storelist-body__letter
// If not found : add class 'disabled' to link
export function disableNonExistantLetters() {
  // For each letter from bloc-letters...
  $('.storelist-bloc-letters a').each((i, elt) => {
    const letter = elt.innerText;
    const titleLetter = $(
      `#country-list-wrapper h3.storelist-body__letter:contains("${letter}")`
    );

    // If header is non-existent : add 'disable' class to letter link
    if (titleLetter.length === 0) elt.classList.add('disabled');
  });
};





// WEBPACK FOOTER //
// ./src/store/store-list/store-list-letters.js